var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVisa(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "45px",
    height: "27px",
    viewBox: "0 0 45 27",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon/cc/visa") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Payment-Pages",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "No-Previous-Payment-Stored-for-Client--CCD-Add-Card",
    transform: "translate(-624.000000, -737.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Stacked-Group",
    transform: "translate(624.000000, 737.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon/cc/visa"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Visa-light"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#636176",
    strokeWidth: 0.5,
    fill: "#FFFFFF",
    x: 0.25,
    y: 0.25,
    width: 43.9473946,
    height: 26.5,
    rx: 1.50786919
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-1",
    fill: "#26337A",
    points: "18.4412199 17.7960423 19.8078606 9.21270423 21.9923865 9.21270423 20.6258708 17.7960423 18.4412199 17.7960423"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5498376,9.42338028 C28.1179052,9.25111268 27.4385831,9.06325352 26.5923355,9.06325352 C24.4325485,9.06325352 22.9122264,10.2280563 22.899607,11.8959718 C22.8858631,13.1297324 23.9844983,13.8177887 24.812754,14.2278592 C25.6639994,14.6481972 25.9499969,14.9171831 25.9466234,15.2930282 C25.940751,15.8678873 25.2671763,16.1312958 24.6390814,16.1312958 C23.7644714,16.1312958 23.2998036,16.0016197 22.5813739,15.681169 L22.3003742,15.5445211 L21.9948854,17.465831 C22.5042833,17.7049014 23.4486122,17.9124085 24.4286752,17.9233099 C26.7240267,17.9233099 28.2154867,16.7725775 28.2329789,14.9914648 C28.2408504,14.0131268 27.658735,13.2715775 26.3980471,12.6593239 C25.6346375,12.2612958 25.1660964,11.9976338 25.171469,11.5947887 C25.1719688,11.2380845 25.5672925,10.8561549 26.422911,10.8561549 C27.1374674,10.844493 27.6547368,11.0115634 28.057807,11.1859859 L28.2539696,11.2840986 L28.5498376,9.42338028",
    id: "Fill-2",
    fill: "#26337A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.4586656,14.7529014 C31.6397099,14.2595493 32.3289026,12.3537042 32.3289026,12.3537042 C32.3161583,12.3763944 32.5089473,11.8565493 32.6192731,11.534831 L32.7667074,12.2751127 C32.7667074,12.2751127 33.1858955,14.3238169 33.272232,14.7529014 L31.4586656,14.7529014 L31.4586656,14.7529014 Z M34.1537139,9.2214507 L32.4654667,9.2214507 C31.9418252,9.2214507 31.549875,9.37330986 31.3204772,9.93295775 L28.0762988,17.7990845 L30.3707757,17.7990845 C30.3707757,17.7990845 30.7451088,16.7408873 30.8300709,16.508662 C31.0803343,16.508662 33.3098402,16.5130986 33.6280733,16.5130986 C33.6935441,16.8126338 33.8940797,17.7990845 33.8940797,17.7990845 L35.9216756,17.7990845 L34.1537139,9.2214507 L34.1537139,9.2214507 Z",
    id: "Fill-3",
    fill: "#26337A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6085371,9.21992958 L14.4703655,15.0717042 L14.2413426,13.8821831 C13.8428953,12.5116479 12.6025733,11.0261408 11.2151919,10.2818028 L13.1713197,17.7885634 L15.4832888,17.787169 L18.9235049,9.21992958 L16.6085371,9.21992958",
    id: "Fill-4",
    fill: "#26337A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4855005,9.21409859 L8.96269628,9.21409859 L8.9337092,9.39194366 C11.674862,10.1029437 13.4885533,11.8191549 14.2413426,13.8821831 L13.4758089,9.93828169 C13.3437428,9.39435211 12.959914,9.23311268 12.4855005,9.21409859",
    id: "Fill-5",
    fill: "#EC982D"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/visa.7730b05d6873eb55f691de9d599b4fec.svg";
export { ForwardRef as ReactComponent };